<template>
  <div>
    <div class="info-text">
      <slot></slot>
      <div class="variant-icon">
        <div v-if="variant == 'info'" class="icon-info"></div>
        <div v-else-if="variant == 'help'" class="icon-help"></div>
        <div v-else-if="variant == 'legal'" class="icon-book-open"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {

    };
  },
  props: {
    variant: {
      required: true,
    }
  }
}
</script>
<style>
.info-text {
  position: relative;
  padding: 20px;
  padding-left: 30px;
  /* margin-left: 5px; */
  margin-bottom: 25px;

  border-left: 3px solid #343a40;
  background-color: #dee2e6;
}
.variant-icon {
  position: absolute;
  top: 24px;
  left: -11px;
  width: 20px;
  height: 20px;
  padding-top: 1px;

  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;

  background-color: #343a40;
  color: #ffffff;
  font-size: 12px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/98_ui/TextBox.vue